module.exports = __webpack_public_path__ + "img/offer4.4071c406.jpg";